import { Accordion, AccordionSummary, Box, Typography } from '@mui/material'
import { ReactComponent as ArrowIcon } from '../../assets/images/TAGArrow.svg'
import { IAccordionTag } from './types'
import { useEffect, useState } from 'react'
import colors from '../../constants/colors'

const AccordionTAG: React.FC<IAccordionTag> = ({
  children,
  boxError,
  variant = 'accordionNormal',
  title,
  color = 'tagBoxSuccess',
}) => {
  const [type, setType] = useState(color)
  const [expand, setExpand] = useState(true)
  const toggleAcordion = () => {
    setExpand(prev => !prev)
  }

  useEffect(() => {
    if (boxError) {
      setType('tagBoxError')
    }
  }, [])

  const resolveArrow = () => {
    if (color === 'tagBoxArchive') {
      return <ArrowIcon className='t-accordion-expand-icon' fill={colors.BLACK} />
    }
    if (variant === 'accordionOutlined') {
      return (
        <ArrowIcon
          className='t-accordion-expand-icon'
          fill={boxError ? colors.TAG_RED : colors.TAG_BLUE}
        />
      )
    }
    return (
      <ArrowIcon
        className='t-accordion-expand-icon'
        stroke={boxError ? colors.TAG_RED : colors.TAG_BLUE}
      />
    )
  }

  return (
    <Box sx={{ width: '100%' }}>
      <Accordion
        elevation={0}
        variant={variant}
        sx={{
          color: `${type}.text`,
          borderColor: `${variant === 'accordionOutlined' ? `${type}.border` : 'transparent'}`,
        }}
        expanded={expand}
      >
        <AccordionSummary
          expandIcon={resolveArrow()}
          sx={{
            borderColor: `${type}.border`,
            backgroundColor: `${
              variant === 'accordionOutlined' ? `${type}.background` : 'transparent'
            }`,
          }}
          onClick={toggleAcordion}
        >
          <Typography variant={`${variant === 'accordionOutlined' ? 'h3' : 'h1'}`}>
            {title}
          </Typography>
        </AccordionSummary>
        {children}
      </Accordion>
    </Box>
  )
}

export default AccordionTAG
